export default class AbstractComponentController {
    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;

        this.translate = this.injector.get('$translate');
    }
}

AbstractComponentController.$inject = [
    '$scope',
    '$injector',
    '$element'
];



// WEBPACK FOOTER //
// ./src/app/modules/core/abstracts/controllers/component-controller.js